var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"mt-4 px-5",attrs:{"fluid":""}},[(_vm.verTicketsJefe)?_c('TicketArea'):_vm._e(),(_vm.verTicketsAuxiliar)?_c('TicketAuxi'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }